import { faCalendarCheck, faCalendarDays, faCalendarXmark } from "@fortawesome/free-solid-svg-icons"

export const tiposAgendamentosUtils = () => {


    return [
        {
            id: 1,
            nome: 'Agendamento',
            color: '',
            colorLight: '',
            classEvent: "ev_agenda"

        }, {
            id: 2,
            nome: 'Anotações',
           color: 'rgb(189 143 6) ',
            colorLight: 'rgba(255, 193, 7, 0.05)',
            classEvent: "ev_anotacao",
            classColorTitle:'text-warning'
        }, {
            id: 3,
            nome: 'Bloqueio',
            color: '#dc3545',
            colorLight: 'rgba(220, 53, 69, 0.05)',
            classEvent: "ev_bloqueio",
            classColorTitle:'text-danger'

        }
    ]
}